import React from 'react';
import CommonHeader from '../../../Components/Common/Headers/CommonHeader';
import ProjectLists from '../../../Components/ProjectComponents/ProjectsLandingComponents/ProjectLists/ProjectLists';
import Footer from '../../../Components/Common/Footer/Footer';

const ProjectsLanding = () => {
  return (
    <main id="app">
      {/* ----- common header ------------- */}
      <CommonHeader moduleName="projects" />

      <div id="main_content" className="position-relative">
        {/* ----- projects section ------- */}
        <ProjectLists />
      </div>

      {/* ----------- footer --------- */}
      <Footer />
    </main>
  );
};

export default ProjectsLanding;
